<template>
  <div>
    <base-button
      simple
      type="primary"
      class="animation-on-hover mt-1"
      @click="redirectToNotificationList()"
    >
      <i class="tim-icons icon-bell-55"></i>
      <badge type="primary" v-if="unreadNotificationsCount > 0">{{ unreadNotificationsCount }}</badge>
    </base-button>
  </div>
</template>

<script>
import axios from 'axios';
import * as Cookies from "js-cookie";
import { Badge } from '@/resources/components';
import notificationPusherChannel from '@/resources/mixins/notificationPusherChannel';

export default {
  name: 'SystemNotificationButton',
  components: {
    Badge,
  },
  mixins: [
    notificationPusherChannel,
  ],
  data() {
    return {
      unreadNotificationsCount: 0,
      base: document.location.protocol + "//" + process.env.VUE_APP_API_HOST,
    }
  },
  watch: {
    unreadNotificationsCount(newValue, oldValue) {
      this.$store.commit('pageTitle', newValue);
    }
  },
  computed: {
    token() {
      return Cookies.getJSON("token");
    },
  },
  created() {
    this.getUnreadSystemNotificationCount();
  },
  methods: {
    redirectToNotificationList() {
      this.$set(this, 'unreadNotificationsCount', 0);

      this.$router.push({ name: `${this.token.user.role.name}.notification` });
    },
    afterSystemNotificationCreated(newNotification) {
      this.unreadNotificationsCount++;

      this.$notify({
        title: newNotification.title,
        message: newNotification.description,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        type: 'primary',
      });
    },
    async getUnreadSystemNotificationCount() {
      const headers = {'Authorization': `Bearer ${this.token.access_token}`};
      axios.get(this.base + '/api/system_notifications/unread_count', {headers: headers})
        .then((response) => {
          this.$set(this, 'unreadNotificationsCount', response.data.data.unread_count);
        })
    },
  }
}
</script>

<style>

</style>